import { gql } from '@apollo/client';
const ADD_ORDER_MODELS = gql `
  mutation AddOrderModels($modelSpecificationIds: [ID!], $orderId: String!) {
    addOrderModelNodes(modelSpecificationIds: $modelSpecificationIds, orderId: $orderId) {
      id
    }
  }
`;
export default ADD_ORDER_MODELS;
